import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelText as _vModelText, withDirectives as _withDirectives, vModelSelect as _vModelSelect, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle } from "vue";
const _hoisted_1 = {
  key: 0,
  style: {
    "width": "100%"
  }
};
const _hoisted_2 = {
  style: {
    "width": "100%",
    "font-weight": "bold",
    "color": "#fff",
    "background-color": "#000",
    "padding": "0 1rem",
    "margin-bottom": "0.5rem"
  }
};
const _hoisted_3 = {
  style: {
    "width": "100%",
    "padding": "0 1rem"
  }
};
const _hoisted_4 = {
  style: {
    "width": "100%",
    "display": "flex",
    "justify-content": "space-between",
    "align-items": "center",
    "height": "2.5rem"
  }
};
const _hoisted_5 = {
  class: "flex-start",
  style: {
    "align-items": "center",
    "width": "50%"
  }
};
const _hoisted_6 = {
  style: {
    "width": "fit-content"
  }
};
const _hoisted_7 = ["onUpdate:modelValue", "onChange", "disabled"];
const _hoisted_8 = {
  style: {
    "width": "20%"
  },
  class: "flex-center"
};
const _hoisted_9 = ["onUpdate:modelValue", "onChange", "disabled"];

const _hoisted_10 = /*#__PURE__*/_createElementVNode("option", {
  value: "0"
}, null, -1);

const _hoisted_11 = ["value"];
const _hoisted_12 = {
  style: {
    "width": "30%"
  },
  class: "flex-end"
};
const _hoisted_13 = ["onClick", "disabled"];
const _hoisted_14 = ["set"];

const _hoisted_15 = /*#__PURE__*/_createElementVNode("div", {
  class: "flex-start",
  style: {
    "align-items": "center",
    "width": "50%"
  }
}, null, -1);

const _hoisted_16 = /*#__PURE__*/_createElementVNode("div", {
  style: {
    "width": "20%"
  },
  class: "flex-center"
}, null, -1);

const _hoisted_17 = {
  style: {
    "width": "30%"
  },
  class: "flex-end"
};
const _hoisted_18 = ["disabled"];
const _hoisted_19 = {
  key: 1,
  style: {
    "width": "100%"
  }
};
const _hoisted_20 = {
  style: {
    "width": "100%",
    "font-weight": "bold",
    "color": "#fff",
    "background-color": "#000",
    "padding": "0 1rem",
    "margin-bottom": "0.5rem"
  }
};
const _hoisted_21 = {
  style: {
    "width": "100%",
    "padding": "0 1rem"
  }
};
const _hoisted_22 = ["innerHTML"];
const _hoisted_23 = {
  class: "flex-between",
  style: {
    "width": "100%",
    "margin": "1rem 0"
  }
};
const _hoisted_24 = ["onClick", "disabled"];
const _hoisted_25 = {
  key: 2,
  class: "flex-between",
  style: {
    "width": "100%"
  }
};
const _hoisted_26 = {
  style: {
    "width": "45%",
    "display": "flex",
    "justify-content": "space-between",
    "align-items": "center",
    "height": "2.5rem",
    "padding": "0 1rem"
  }
};
const _hoisted_27 = {
  class: "flex-start",
  style: {
    "align-items": "center"
  }
};
const _hoisted_28 = {
  style: {
    "width": "fit-content"
  }
};
const _hoisted_29 = {
  class: "flex-center"
};
const _hoisted_30 = ["onUpdate:modelValue", "onChange", "disabled"];

const _hoisted_31 = /*#__PURE__*/_createElementVNode("option", {
  value: "0"
}, null, -1);

const _hoisted_32 = ["value"];
const _hoisted_33 = {
  key: 3,
  class: "flex-center",
  style: {
    "width": "100%",
    "padding": "0 1rem"
  }
};
const _hoisted_34 = ["set"];
const _hoisted_35 = {
  key: 4,
  style: {
    "width": "100%"
  }
};
const _hoisted_36 = {
  style: {
    "width": "100%",
    "font-weight": "bold",
    "color": "#fff",
    "background-color": "#000",
    "padding": "0 1rem",
    "margin-bottom": "0.5rem"
  }
};
const _hoisted_37 = {
  style: {
    "width": "100%",
    "padding": "0 1rem",
    "margin-bottom": "0.5rem"
  }
};
const _hoisted_38 = {
  key: 5,
  style: {
    "width": "100%",
    "padding-bottom": "1rem"
  }
};
const _hoisted_39 = {
  style: {
    "width": "100%",
    "font-weight": "bold",
    "color": "#fff",
    "background-color": "#000",
    "padding": "0 1rem",
    "margin-bottom": "0.5rem"
  }
};
const _hoisted_40 = {
  style: {
    "width": "100%",
    "padding": "0 1rem"
  }
};
const _hoisted_41 = ["innerHTML"];
const _hoisted_42 = {
  style: {
    "width": "fit-content",
    "font-weight": "bold"
  }
};
const _hoisted_43 = {
  class: "flex-between",
  style: {
    "width": "100%",
    "margin-bottom": "1rem"
  }
};
const _hoisted_44 = ["disabled"];
const _hoisted_45 = {
  key: 6
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_Editor = _resolveComponent("Editor");

  return $props.step.type == 'questionAnswer' && _ctx.userType == 'admin' ? (_openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, _toDisplayString(_ctx._t("content")), 1), _createElementVNode("div", _hoisted_3, [_createVNode(_component_Editor, {
    modelValue: $props.step.content,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => $props.step.content = $event),
    onChange: _cache[1] || (_cache[1] = $event => $options.changeQuestionStepContent($event, $props.step)),
    disabled: $props.disabled
  }, null, 8, ["modelValue", "disabled"]), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.step.answerStep, (_answerStep, _answerIndex) => {
    return _openBlock(), _createElementBlock("div", _hoisted_4, [_createElementVNode("div", _hoisted_5, [_createElementVNode("div", _hoisted_6, _toDisplayString(_answerIndex + 1) + ".", 1), _withDirectives(_createElementVNode("input", {
      class: "input-self",
      type: "text",
      style: {
        "width": "90%",
        "height": "2rem"
      },
      "onUpdate:modelValue": $event => _answerStep.content = $event,
      onChange: $event => $options.changeAnswerStepContent(_answerStep),
      disabled: $props.disabled
    }, null, 40, _hoisted_7), [[_vModelText, _answerStep.content]])]), _createElementVNode("div", _hoisted_8, [_createElementVNode("span", null, _toDisplayString(_ctx._t("nextStep")) + "：", 1), _withDirectives(_createElementVNode("select", {
      "onUpdate:modelValue": $event => _answerStep.next_question_step_id = $event,
      style: {
        "min-width": "3rem"
      },
      onChange: $event => $options.changeAnswerStepNextQuestionStep(_answerStep),
      disabled: $props.disabled
    }, [_hoisted_10, (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.question.questionStep, _step => {
      return _openBlock(), _createElementBlock("option", {
        value: _step.id
      }, _toDisplayString(Number(_step.index) + 1), 9, _hoisted_11);
    }), 256))], 40, _hoisted_9), [[_vModelSelect, _answerStep.next_question_step_id]])]), _createElementVNode("div", _hoisted_12, [_createElementVNode("button", {
      class: "btn btn-self",
      style: {
        "height": "2rem",
        "margin-left": "0.5rem"
      },
      onClick: $event => $options.clickDeleteAnswerStep(_answerStep),
      disabled: $props.disabled
    }, _toDisplayString(_ctx._t("delete")), 9, _hoisted_13)])]);
  }), 256)), _createElementVNode("div", {
    style: {
      "width": "100%",
      "display": "flex",
      "justify-content": "space-between",
      "align-items": "center",
      "height": "2.5rem"
    },
    set: $props.step.newAnswerStep = $props.step.newAnswerStep || {
      content: '',
      next_question_step_id: 0
    }
  }, [_hoisted_15, _hoisted_16, _createElementVNode("div", _hoisted_17, [_createElementVNode("button", {
    class: "btn btn-self",
    style: {
      "height": "2rem",
      "margin-left": "0.5rem"
    },
    onClick: _cache[2] || (_cache[2] = $event => $options.clickAddAnswerStep($props.step)),
    disabled: $props.disabled
  }, _toDisplayString(_ctx._t("add")), 9, _hoisted_18)])], 8, _hoisted_14)])])) : $props.step.type == 'questionAnswer' && _ctx.userType == 'user' ? (_openBlock(), _createElementBlock("div", _hoisted_19, [_createElementVNode("div", _hoisted_20, _toDisplayString(_ctx._t("content")), 1), _createElementVNode("div", _hoisted_21, [_createElementVNode("div", {
    style: {
      "width": "100%",
      "border": "1px solid #000",
      "min-height": "2rem",
      "overflow": "scroll"
    },
    innerHTML: $props.step.content
  }, null, 8, _hoisted_22), _createElementVNode("div", _hoisted_23, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.step.answerStep, (_answerStep, _answerStepIndex) => {
    return _openBlock(), _createElementBlock("button", {
      class: "btn btn-self",
      onClick: $event => {
        $options.clickNextQuestionStep(_answerStep);
        _answerStep.selected = true;
      },
      disabled: $props.disabled,
      style: _normalizeStyle({
        'background-color': _answerStep.selected ? '#999' : ''
      })
    }, _toDisplayString(Number(_answerStepIndex) + 1) + "." + _toDisplayString(_answerStep.content), 13, _hoisted_24);
  }), 256))])])])) : $props.step.type == 'login' && _ctx.userType == 'admin' ? (_openBlock(), _createElementBlock("div", _hoisted_25, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.step.answerStep, (_answerStep, _answerIndex) => {
    return _openBlock(), _createElementBlock("div", _hoisted_26, [_createElementVNode("div", _hoisted_27, [_createElementVNode("div", _hoisted_28, _toDisplayString(_answerIndex + 1) + "." + _toDisplayString(_ctx._t(_answerStep.content)), 1)]), _createElementVNode("div", _hoisted_29, [_createElementVNode("span", null, _toDisplayString(_ctx._t("nextStep")) + "：", 1), _withDirectives(_createElementVNode("select", {
      "onUpdate:modelValue": $event => _answerStep.next_question_step_id = $event,
      style: {
        "min-width": "3rem"
      },
      onChange: $event => $options.changeAnswerStepNextQuestionStep(_answerStep),
      disabled: $props.disabled
    }, [_hoisted_31, (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.question.questionStep, _step => {
      return _openBlock(), _createElementBlock("option", {
        value: _step.id
      }, _toDisplayString(Number(_step.index) + 1), 9, _hoisted_32);
    }), 256))], 40, _hoisted_30), [[_vModelSelect, _answerStep.next_question_step_id]])])]);
  }), 256))])) : $props.step.type == 'login' && _ctx.userType == 'user' ? (_openBlock(), _createElementBlock("div", _hoisted_33, [_createElementVNode("div", {
    style: {
      "font-weight": "bold"
    },
    set: $options.loadIdentify()
  }, _toDisplayString(_ctx.user.id ? _ctx._t("loginSuccess") : _ctx._t("loginNeed")), 9, _hoisted_34)])) : $props.step.type == 'goToChat' && _ctx.userType == 'admin' ? (_openBlock(), _createElementBlock("div", _hoisted_35, [_createElementVNode("div", _hoisted_36, _toDisplayString(_ctx._t("content")), 1), _createElementVNode("div", _hoisted_37, [_createVNode(_component_Editor, {
    modelValue: $props.step.content,
    "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => $props.step.content = $event),
    onChange: _cache[4] || (_cache[4] = $event => $options.changeQuestionStepContent($event, $props.step)),
    disabled: $props.disabled
  }, null, 8, ["modelValue", "disabled"])])])) : $props.step.type == 'goToChat' && _ctx.userType == 'user' ? (_openBlock(), _createElementBlock("div", _hoisted_38, [_createElementVNode("div", _hoisted_39, _toDisplayString(_ctx._t("content")), 1), _createElementVNode("div", _hoisted_40, [_createElementVNode("div", {
    style: {
      "width": "100%",
      "border": "1px solid #000",
      "min-height": "2rem"
    },
    innerHTML: $props.step.content
  }, null, 8, _hoisted_41), _createElementVNode("div", _hoisted_42, _toDisplayString(_ctx._t("answer")), 1), _createElementVNode("div", _hoisted_43, [_createElementVNode("button", {
    class: "btn btn-self",
    onClick: _cache[5] || (_cache[5] = $event => {
      $options.clickChatNow($props.question);
    }),
    disabled: $props.disabled
  }, _toDisplayString(_ctx._t('chatNow')), 9, _hoisted_44)])])])) : $props.step.type == 'orderInfo' ? (_openBlock(), _createElementBlock("div", _hoisted_45)) : _createCommentVNode("", true);
}